require('bootstrap');
import bsCustomFileInput from "bs-custom-file-input";

$(function() {
    bsCustomFileInput.init();
})

global.bsCustomFileInput = bsCustomFileInput;
